<template>
	<div :id="'cs-'+identify" class="text-center">
		<span v-for="(n, i) in number" class="counter-style" :class="{'resolution':is_res}" :key="identify+'-'+n+'-'+i">{{n}}</span>
	</div>
</template>

<script>
export default {
	data(){
		return {
			number: []
		}
	},
	props: ['identify', 'value', 'is_res'],
	methods: {
		animateValue(start, end, duration){
			let startTimestamp = null
			const step = (timestamp) => {
				if (!startTimestamp) startTimestamp = timestamp;
				const progress = Math.min((timestamp - startTimestamp) / duration, 1)
				this.number = Math.floor(progress * (end - start) + start).toString().split('')

				if (progress < 1) {
					window.requestAnimationFrame(step)
				}
			}
			window.requestAnimationFrame(step)
		}
	},
	mounted(){
		this.animateValue(0, this.value, 2000)
	}
}
</script>

<style>
	.counter-style {
		background:rgba(255,255,255,.3);
		padding:10px;
		border-radius: 10px;
		font-size: 6rem;
		margin:2px;
	}
	.counter-style.resolution {
		background-image: linear-gradient(45deg,#5374fa 20%,#ff6969 89.95%);
	}
</style>